import log from "loglevel"
import prefixer from "loglevel-plugin-prefix"

prefixer.reg(log) //register the loglevel-plugin-prefix with the loglevel library

// TODO - read from environment and different values for server/client
//const mainLevel = log.levels.INFO
const mainLevel = log.levels.DEBUG

const perfLevel = log.levels.INFO
//const perfLevel = log.levels.DEBUG

// create and configure the main (default) logger
export const mainLogger = log.getLogger("MAIN")
mainLogger.setLevel(mainLevel)
prefixer.apply(mainLogger, { template: "[%t] %l:" })

// create and configure the PERF logger
export const perfLogger = log.getLogger("PERF")
perfLogger.setLevel(perfLevel)
prefixer.apply(perfLogger, { template: "[%t] PERF:" })

mainLogger.info("LOGGING INITIALIZED with level", mainLogger.getLevel())

export function isDebugEnabled(logger: log.Logger = mainLogger): boolean {
  return logger.getLevel() <= log.levels.DEBUG
}
